// AUTH-2 — login error classification shared by the staff and portal sign-in pages.
// Rate limiting (429 TOO_MANY_ATTEMPTS) is distinguished from invalid credentials; every other
// failure keeps the generic message (no account enumeration, no threshold internals).

export const GENERIC_LOGIN_MESSAGE = 'Login failed. Please check your credentials.';
export const RATE_LIMIT_CODE = 'TOO_MANY_ATTEMPTS';
export const DEFAULT_LOCK_SECONDS = 15 * 60;

function errorObject(err) {
  const data = err?.response?.data;
  return data?.error || data?.detail?.error || null;
}

export function classifyLoginError(err) {
  const status = err?.response?.status;
  const errObj = errorObject(err);
  const code = err?.errorCode || errObj?.code;
  if (status === 429 || code === RATE_LIMIT_CODE) {
    const details = err?.errorDetails || errObj?.details || {};
    const headerRetry = Number(err?.response?.headers?.['retry-after']);
    const bodyRetry = Number(err?.retryAfterSeconds ?? details.retry_after_seconds);
    const lockedUntil = err?.lockedUntil || details.locked_until || null;
    let retryAfterSeconds = Number.isFinite(bodyRetry) && bodyRetry > 0 ? bodyRetry : null;
    if (retryAfterSeconds == null && Number.isFinite(headerRetry) && headerRetry > 0) retryAfterSeconds = headerRetry;
    if (retryAfterSeconds == null && lockedUntil) {
      const ms = Date.parse(lockedUntil) - Date.now();
      if (Number.isFinite(ms) && ms > 0) retryAfterSeconds = Math.ceil(ms / 1000);
    }
    return { kind: 'RATE_LIMITED', retryAfterSeconds: retryAfterSeconds ?? DEFAULT_LOCK_SECONDS, lockedUntil };
  }
  return { kind: 'GENERIC', message: GENERIC_LOGIN_MESSAGE };
}

export function formatCountdown(totalSeconds) {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}
